import React, { useState, useEffect} from "react";  // Asegúrate de que useRef esté importado
import portada from "../Images/portada51.webp";
import logoWhatsapp from "../Images/logo-whatsapp1.png";
import universidad from "../Images/university.svg";
import tesis from "../Images/tesis.svg";
import graduation from "../Images/graduation.svg";
import { FaUsers, FaCheckCircle, FaChartLine } from 'react-icons/fa';
import secondMain from "../Images/Sr.-DiegoGerente.webp";
import "../Css/inicio.css";
import ucv from "../Images/ucv.png";
import unt from "../Images/unt.png";
import upn from "../Images/upn.png";
import upao from "../Images/upao.jpeg";
import uct from "../Images/uct.png";
import usp from "../Images/usp.jpeg";
import Footer from "../Components/footer";

function Inicio() {
  const [universitiesCount, setUniversitiesCount] = useState(16);
  const [thesisCount, setThesisCount] = useState(100);
  const [clientsCount, setClientsCount] = useState(100);
  const [shouldAnimate, setShouldAnimate] = useState(false);

  // Función para los contadores
  const countUpTo = (setState, end, speed = 50) => {
    let start = 0;
    const interval = setInterval(() => {
      if (start < end) {
        start++;
        setState(start);
      } else {
        clearInterval(interval);
      }
    }, speed);
    return () => clearInterval(interval);
  };

  useEffect(() => {
    // Generar un ID único para esta carga de página
    const currentPageLoadId = Date.now().toString();
    
    // Comparar con el ID almacenado (si existe)
    const lastPageLoadId = sessionStorage.getItem('pageLoadId');
    
    // Si el ID es diferente o no existe, significa que es una recarga completa
    if (lastPageLoadId !== currentPageLoadId) {
      // Guardar el nuevo ID de carga
      sessionStorage.setItem('pageLoadId', currentPageLoadId);
      
      // Activar animación
      setShouldAnimate(true);
      
      // Resetear contadores para la animación
      setUniversitiesCount(0);
      setThesisCount(0);
      setClientsCount(0);
    }
  }, []);

  useEffect(() => {
    // Ejecutar los contadores solo si debe animar
    if (shouldAnimate) {
      const cleanupUniversities = countUpTo(setUniversitiesCount, 16, 50);
      const cleanupThesis = countUpTo(setThesisCount, 100, 10);
      const cleanupClients = countUpTo(setClientsCount, 100, 10);
      
      // Limpiar intervalos cuando el componente se desmonte
      return () => {
        cleanupUniversities();
        cleanupThesis();
        cleanupClients();
      };
    }
  }, [shouldAnimate]);

  return (
    <div className="main_panel_inicio">
      {/* Sección Hero con imagen y estadísticas */}
      <div className="hero-section">
        <div className="container_img_portada">
          <img src={portada} alt="Portada" className="img_portada" />
          <div className="hero-content">
            <h1 className="title">
              ¡Tu éxito académico comienza aquí con nuestros asesores especializados!
            </h1>
            <div className="hero-buttons">
              <a href="/servicios" className="btn-primary">Nuestros Servicios</a>
              <a href="/contact" className="btn-secondary">Contáctanos</a>
            </div>
          </div>
        </div>
        <div className="cuadro_indicadores">
          <div className="stat-item">
            <div className="stat-number-container">
              <img src={universidad} alt="universidad" className="icon" />
              <span className="stat-number">+{universitiesCount}</span>
            </div>
            <span className="stat-text">UNIVERSIDADES</span>
          </div>
          <div className="divider"></div>
          <div className="stat-item">
            <div className="stat-number-container">
              <img src={tesis} alt="universidad" className="icon" />
              <span className="stat-number">+{thesisCount}</span>
            </div>
            <span className="stat-text">TESIS APROBADAS</span>
          </div>
          <div className="divider"></div>
          <div className="stat-item">
            <div className="stat-number-container">
              <img src={graduation} alt="graduation" className="icon" />
              <span className="stat-number">{clientsCount}%</span>
            </div>
            <span className="stat-text">CLIENTES SATISFECHOS</span>
          </div>
        </div>
      </div>

      <section className="why-us-section">
        <div className="container">
          <h2 className="section-title">Confía en los Mejores</h2>
          <div className="row">
            <div className="img-container col-12 col-md-6">
              <img src={secondMain} alt="Imagen de fondo" className="img-second-main" />
            </div>
            <div className="info-container col-12 col-md-6">
              {/* Bloques con fondo gris claro y bordes redondeados */}
              <div className="block-container">
                <div className="block feature-item">
                  <div className="feature-icon">
                    <FaUsers />
                  </div>
                  <h3>Equipo Especializado</h3>
                  <p>Profesionales con amplia experiencia académica en diversas disciplinas.</p>
                </div>
                <div className="block feature-item">
                  <div className="feature-icon">
                    <FaCheckCircle />
                  </div>
                  <h3>Originalidad</h3>
                  <p>Garantizamos trabajos libres de plagio verificados con software especializado.</p>
                </div>
                <div className="block feature-item">
                  <div className="feature-icon">
                    <FaChartLine />
                  </div>
                  <h3>Resultados Comprobados</h3>
                  <p>Más de 100 tesis aprobadas y clientes satisfechos respaldan nuestro trabajo.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="title-container">
        <h2 className="section-title">Expertos en tesis universitarias a nivel nacional</h2> 
      </div>
      {/* Carrusel de imágenes de insignias */}
      <div className="image-carousel">
        <div className="carousel-wrapper">
          <div className="carousel-item">
            <img src={ucv} alt="Insignia UCV" />
          </div>
          <div className="carousel-item">
            <img src={unt} alt="Insignia UNT" />
          </div>
          <div className="carousel-item">
            <img src={upn} alt="Insignia UPN" />
          </div>
          <div className="carousel-item">
            <img src={upao} alt="Insignia UPAO" />
          </div>
          <div className="carousel-item">
            <img src={uct} alt="Insignia UCT" />
          </div>
          <div className="carousel-item">
            <img src={usp} alt="Insignia USP" />
          </div> 
          {/* Duplicamos las imágenes para crear el efecto infinito */}
          <div className="carousel-item">
            <img src={ucv} alt="Insignia UCV" />
          </div>
          <div className="carousel-item">
            <img src={unt} alt="Insignia UNT" />
          </div>
          <div className="carousel-item">
            <img src={upn} alt="Insignia UPN" />
          </div>
          <div className="carousel-item">
            <img src={upao} alt="Insignia UPAO" />
          </div>
          <div className="carousel-item">
            <img src={uct} alt="Insignia UCT" />
          </div>
          <div className="carousel-item">
            <img src={usp} alt="Insignia SUP" />
          </div>  
        </div>
      </div>

      <Footer />

      

      {/* Botón flotante de WhatsApp */}
      <a
        href="https://wa.me/51961867761"
        target="_blank"
        rel="noopener noreferrer"
        className="btn-circle whatsapp-btn-inicio"
      >
        <img
          src={logoWhatsapp}
          alt="WhatsApp"
          className="whatsapp-icon-inicio"
        />
      </a>
    </div>
  );
}

export default Inicio;
